import { NuvoImporter, nuvoSession, RejectSubmitResult } from 'nuvo-react';
import _ from 'lodash';
import '../styles.css';
import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useApolloClient } from '@apollo/client';
import { MasterDataQry } from '../gql/MasterDataQry';
import { currencyJsn } from './currencyJsn';
import { CREATE_REGION } from '../graphqlDefs/region/mutations';
import { CURRENCYLIST } from '../constants/Currency';
import { REGIONSLIST } from '../constants/Regions';

const MasterApp = () => {
  const client = useApolloClient();
  const licenseKey = process.env.REACT_APP_LICENSE_KEY;
  const [result, setResult] = useState(
    'Your output data will be displayed here'
  );
  const [currencyD, setCurrencyD] = useState([]);
  const [apiData, setApiData] = useState('');
  const masterData = useQuery(MasterDataQry);

  const importData = () => {
    const currenciesInfo =
      masterData.data && masterData.data?.currencies
        ? masterData.data?.currencies
        : '>>';
    const countriesInfo =
      masterData.data && masterData.data?.countries
        ? masterData.data?.countries
        : '>>';
    const newData = currenciesInfo.map(({ __typename, ...rest }) => rest);
    const countryData = countriesInfo.map(({ __typename, ...rest }) => rest);
    setCurrencyD(currencyJsn);
    setApiData(CURRENCYLIST);
    const countryDropdown = transformCountryList(countryData);
  };

  function transformCountryList(countryData) {
    const trimmedAndUppercasedCountries = countryData.map((country) => ({
      value: country.value.trim().toUpperCase(),
    }));
    return trimmedAndUppercasedCountries;
  }
  useEffect(() => {
    if (apiData) {
      nuvoSession.upload({
        step: 'review',
        data: apiData,
        headerIndex: undefined,
      });
      nuvoSession.start();
    }
  }, [apiData]);

  // Below function we are calling after submission and will push to database
  async function saveMasters(res) {
    let flg = '';

    if (res !== '' && res.length > 0) {
      await res.map((rItem, rIndex) => {
        let regionArr = { value: rItem.value === '' ? null : rItem.value };
        try {
          client.mutate({
            mutation: CREATE_REGION,
            variables: { input: regionArr },
          });
          flg = 'success';
        } catch (error) {
          flg = 'failed';
          console.error('Error updating post title:', error);
        }
      });
    }
    return flg;
  }
  const handleImportResult = async (res, identifier, complete) => {
    setResult(res);
    const rest = await saveMasters(res);
    if (rest === 'success') {
      complete();
    } else {
      complete(new RejectSubmitResult('Error', 'Something went wrong.'));
    }
  };

  return (
    <div className='App'>
      <div className='container-wrapper'>
        <div>
          <h1>Master Import</h1>
          <div className='button'>
            <div className='import-btn' onClick={importData}>
              Import Data
            </div>
          </div>
          <NuvoImporter
            licenseKey={licenseKey}
            renderUploadButton={() => <div></div>}
            settings={{
              developerMode: true,
              identifier: 'product_data',
              columns: currencyD,
            }}
            onResults={(res, identifier, complete) => handleImportResult(res, identifier, complete)}
          >
            Import data
          </NuvoImporter>
          <div className='white-box'>
            {Object.keys(result).length !== 0 && (
              <pre>
                {typeof result === 'string'
                  ? result
                  : JSON.stringify(result, null, 2)}
              </pre>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default MasterApp;
